module.exports = __webpack_public_path__ + "static/media/tekterkking.576d54b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/tekterkking.png
// module id = 546
// module chunks = 0